import Flickity from "flickity";

export default class BaseIconSlider {
    /**
     * @var {HTMLElement}
     */
    sliderContainer = null;

    /**
     * @var {Flickity}
     */
    slider = null;

    /**
     * @var {NodeListOf<HTMLElement>}
     */
    slides = null;

    /**
     * @var {number}
     */
    tickerSpeed = 0.5;

    /**
     * @var {boolean}
     */
    isPaused = false;

    /**
     * init
     * @return {void}
     */
    init() {
        this.sliderContainer = this.$refs.iconSlider;

        this.initSlider();

        window.addEventListener("resize", () => {
            this.sliderResize();
        });
    }

    /**
     * initSlider
     * @return {void}
     */
    initSlider() {
        if (this.slider !== null) {
            this.slider.destroy();
        }

        let options = {
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            wrapAround: true,
            selectedAttraction: 0.015,
            friction: 0.25,
            on: {
                ready: () => {
                    window.dispatchEvent(new Event("resize"));
                },
                dragStart: () => {
                    this.isPaused = true;
                },
            },
        };

        const update = () => {
            if (!this.isPaused) {
                if (this.slider.slides) {
                    this.slider.x =
                        (this.slider.x - this.tickerSpeed) %
                        this.slider.slideableWidth;
                    this.slider.selectedIndex =
                        this.slider.dragEndRestingSelect();
                    this.slider.updateSelectedSlide();
                    this.slider.settle(this.slider.x);
                }
                window.requestAnimationFrame(update);
            }
        };

        const pause = () => {
            this.isPaused = true;
        };
        const play = () => {
            if (this.isPaused) {
                this.isPaused = false;
                window.requestAnimationFrame(update);
            }
        };

        this.slider = new Flickity(this.sliderContainer, options);

        this.slider.x = 0;

        this.sliderContainer.addEventListener("mouseenter", pause, false);
        this.sliderContainer.addEventListener("focusin", pause, false);
        this.sliderContainer.addEventListener("mouseleave", play, false);
        this.sliderContainer.addEventListener("focusout", play, false);

        update();

        this.slides = this.sliderContainer.querySelectorAll('[data-pegasus-slide]');

        this.sliderResize();

    }

    /**
     * sliderResize
     *
     * @return void
     */
    sliderResize() {
        if (this.sliderContainer === null) return;

        const flickitySliders =
            this.sliderContainer.querySelectorAll(".flickity-slider");


        this.sliderFullWidth = 0;

        flickitySliders.forEach((slider) => {
            let height = 0;

            this.slides.forEach((slide) => {
                slide.style.height = "";
                if (slide.offsetHeight > height) {
                    height = slide.offsetHeight;
                }
            });

            this.slides.forEach((slide) => {
                slide.style.height = height + "px";
            });

            slider.style.height = "";
            slider.style.height = height + "px";
        });
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("iconSlider", () => new BaseIconSlider());
});
